import dynamic from "next/dynamic";

export const Quote = dynamic(() => import("./component"));
